// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LinksStack__Wrapper_3vtOl"};